import type { Action } from 'react-sweet-state';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { connectToBitbucket as connectToBitbucketRequest } from '../../../services';
import { type State, IS_CONNECTED, IS_CONNECTING, READY_TO_CONNECT } from '../types';
import { fireTrackEvent } from './analytics';
import { showGenericErrorFlag } from './flag';

export const startConnection =
	(baseUrl: string, analyticsEvent: UIAnalyticsEvent): Action<State> =>
	async ({ getState, setState, dispatch }) => {
		const { connectState, selectedWorkspaceUuid } = getState();
		if (connectState === IS_CONNECTING) {
			return;
		}

		try {
			setState({ connectState: IS_CONNECTING });
			await connectToBitbucketRequest(baseUrl, selectedWorkspaceUuid);
			setState({ connectState: IS_CONNECTED });
			dispatch(fireTrackEvent(analyticsEvent, selectedWorkspaceUuid, true));
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			dispatch(showGenericErrorFlag());
			setState({ connectState: READY_TO_CONNECT });
			dispatch(fireTrackEvent(analyticsEvent, selectedWorkspaceUuid, false));
		}
	};

export const setSelectedWorkspaceUuid =
	(givenWorkspaceUuid: string): Action<State> =>
	async ({ getState, setState }) => {
		const { selectedWorkspaceUuid } = getState();
		if (selectedWorkspaceUuid === givenWorkspaceUuid) {
			return;
		}

		setState({ selectedWorkspaceUuid: givenWorkspaceUuid });
	};
